<header class="topbar">

  <div>

    <span class="topbar-label">
      Administração
    </span>

    <h1>
      Dashboard
    </h1>

    <p>
      Confira a situação atual das acomodações.
    </p>

  </div>

</header>

<section class="dashboard-cards">


  <div class="dashboard-card">

    <div class="card-icon">
      ▣
    </div>

    <div class="card-info">

      <span>
        Quartos cadastrados
      </span>

      <strong>
        {{ quartos.length }}
      </strong>

    </div>

  </div>


  <div class="dashboard-card">

    <div class="card-icon">
      ✓
    </div>

    <div class="card-info">

      <span>
        Quartos disponíveis
      </span>

      <strong>
        {{ quartosDisponiveis }}
      </strong>

    </div>

  </div>


  <div class="dashboard-card">

    <div class="card-icon">
      !
    </div>

    <div class="card-info">

      <span>
        Quartos indisponíveis
      </span>

      <strong>
        {{ quartosIndisponiveis }}
      </strong>

    </div>

  </div>


</section>
